var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentInstanceActiveApps.length)?_c('div',_vm._l((_vm.currentInstanceActiveApps),function(app){return _c('div',{key:app.sessionId},[_c('ApplicationMenuItem',{attrs:{"appData":app,"collapsed":_vm.collapsed}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }